function getSiteName(){
    return "ss-unbxd-aapac-prod-bigPharmacy69661758605295";
}

function getApiKey(){
    
    return "ca1a93d9131c62380bdae38cbf73232c";
}
(function () {
    'use strict';

    const SLIDER_SUFFIX = 'adks4njdytkdubdk3oaigenblock493bdd4kbptdp';
    const DESKTOP_SLIDES_TO_SCROLL = 3;
    const MOBILE_BREAKPOINT = 749;

    const unbxdUserId = document.cookie.match("\\bunbxd.userId=([^;]*)\\b");
    const unbxdRequestId = unbxdUserId ? unbxdUserId[1] : '123456';

    let pageContext = null;
    let API_URL = null;
    var initializedSliderWrappers = [];
    var resizeListenerAttached = false;
    var resizeRafPending = false;
    var RECS_IO_ROOT_MARGIN = '120px 0px';
    var RECS_IDLE_TIMEOUT_MS = 3000;

    function c(name) {
        return name
            ? 'ai-collection-slider-' + name + '-' + SLIDER_SUFFIX
            : 'ai-collection-slider-' + SLIDER_SUFFIX;
    }

    function ensureArray(val) {
        if (Array.isArray(val)) return val;
        if (val == null) return [];
        return [val];
    }

    function isMobile() {
        return window.innerWidth < MOBILE_BREAKPOINT;
    }

    function formatPrice(price) {
        return parseFloat(price).toLocaleString('en-MY', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        });
    }

    function escapeHtml(text) {
        if (text == null) return '';
        var div = document.createElement('div');
        div.textContent = text;
        return div.innerHTML;
    }

    function getRecsImageUrl(imageUrl) {
        var imgArr = ensureArray(imageUrl);
        var url = imgArr[0] || '';
        if (!url) return '';
        return url.indexOf('?') !== -1 ? url + '&width=600' : url + '?width=600';
    }

    function mapProductFields(value) {
        var price = parseFloat(value.price) || 0;
        var compareAtPrice = parseFloat(value.compareAtPrice) || 0;
        var availability = value.availability;
        var isSoldOut = availability === false || availability === 'false';
        var isOnSale = !isSoldOut && compareAtPrice > 0 && price < compareAtPrice;
        var computedDiscount = parseFloat(value.computed_discount) || 0;

        if (!computedDiscount && isOnSale) {
            computedDiscount = Math.round(((compareAtPrice - price) / compareAtPrice) * 100);
        }

        return {
            title: escapeHtml(value.title || ''),
            uniqueId: value.uniqueId || '',
            productUrl: value.productUrl || ('/products/' + (value.handle || value.uniqueId || '')),
            imageUrl: getRecsImageUrl(value.imageUrl),
            price: price,
            compareAtPrice: compareAtPrice,
            isOnSale: isOnSale,
            computedDiscount: computedDiscount,
            isSoldOut: isSoldOut
        };
    }

    function generateBadgeHTML(product) {
        if (product.computedDiscount > 0) {
            return '<div class="' + c('badge') + '">' + Math.round(product.computedDiscount) + '% OFF</div>';
        }
        return '';
    }

    function generatePriceHTML(product) {
        if (product.isOnSale) {
            return '<span class="' + c('price') + '">RM' + formatPrice(product.price) + '</span>' +
                '<span class="' + c('compare-price') + '">RM' + formatPrice(product.compareAtPrice) + '</span>';
        }
        return '<span class="' + c('price') + '">RM' + formatPrice(product.price) + '</span>';
    }

    function generateProductHTML(value, index, analyticsData) {
        var product = mapProductFields(value);

        return '<div class="' + c('product') + '" id="hz-item-' + index + '"' +
            ' data-id="' + product.uniqueId + '"' +
            ' data-prank="' + index + '"' +
            ' data-unbxdparam_experience_widget="' + (analyticsData.widgetNum ? analyticsData.widgetNum.toUpperCase() : '') + '"' +
            ' data-unbxdparam_experience_pagetype="' + (analyticsData.pageType || '') + '"' +
            ' data-unbxdparam_sku="' + product.uniqueId + '"' +
            ' data-unbxdparam_requestId="' + (unbxdRequestId || '') + '">' +
            '<a href="' + product.productUrl + '" class="' + c('product-link') + '">' +
            '<div class="' + c('image-wrapper') + '">' +
            '<img src="' + product.imageUrl + '" alt="' + product.title + '" class="' + c('image') + '" loading="lazy" width="600" height="600" />' +
            generateBadgeHTML(product) +
            '</div>' +
            '<div class="' + c('product-info') + '">' +
            '<h3 class="' + c('product-title') + '">' + product.title + '</h3>' +
            '<div class="' + c('price-wrapper') + '">' +
            generatePriceHTML(product) +
            '</div>' +
            '</div>' +
            '</a>' +
            '</div>';
    }

    function generateSliderHTML(widget, analyticsData) {
        var heading = widget.widgetTitle || '';
        var recommendations = widget.recommendations || [];

        if (recommendations.length === 0) {
            return '';
        }

        var productsHTML = '';
        recommendations.forEach(function (value, index) {
            productsHTML += generateProductHTML(value, index, analyticsData);
        });

        return '<collection-slider-' + SLIDER_SUFFIX + ' class="' + c('') + '">' +
            '<div class="' + c('container') + '">' +
            '<div class="' + c('header') + '">' +
            '<h2 class="' + c('heading') + '">' + escapeHtml(heading) + '</h2>' +
            '</div>' +
            '<div class="' + c('wrapper') + '">' +
            '<button type="button" class="' + c('arrow') + ' ' + c('arrow-prev') + ' slider-nav-arrow slider-nav-arrow--prev" aria-label="Previous products" data-direction="prev" disabled>' +
            '<svg class="slider-nav-arrow__icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><polyline points="15 18 9 12 15 6"></polyline></svg>' +
            '</button>' +
            '<div class="' + c('track') + '">' +
            productsHTML +
            '</div>' +
            '<button type="button" class="' + c('arrow') + ' ' + c('arrow-next') + ' slider-nav-arrow slider-nav-arrow--next" aria-label="Next products" data-direction="next">' +
            '<svg class="slider-nav-arrow__icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><polyline points="9 18 15 12 9 6"></polyline></svg>' +
            '</button>' +
            '</div>' +
            '</div>' +
            '</collection-slider-' + SLIDER_SUFFIX + '>';
    }

    function getScrollStep(track, slidesToScroll) {
        var item = track.querySelector('.' + c('product'));
        if (!item) return track.clientWidth;
        var gap = parseFloat(window.getComputedStyle(track).gap) || 0;
        return (item.offsetWidth + gap) * slidesToScroll;
    }

    function updateNativeSliderArrowState(wrapper) {
        var track = wrapper.querySelector('.' + c('track'));
        var prevBtn = wrapper.querySelector('.' + c('arrow-prev'));
        var nextBtn = wrapper.querySelector('.' + c('arrow-next'));
        if (!track || !prevBtn || !nextBtn) return;

        var maxScroll = track.scrollWidth - track.clientWidth;
        var threshold = 2;
        var atStart = maxScroll <= 0 || track.scrollLeft <= threshold;
        var atEnd = maxScroll <= 0 || track.scrollLeft >= maxScroll - threshold;

        prevBtn.disabled = atStart;
        nextBtn.disabled = atEnd;
    }

    function initNativeSlider(wrapper) {
        var track = wrapper.querySelector('.' + c('track'));
        var prevBtn = wrapper.querySelector('.' + c('arrow-prev'));
        var nextBtn = wrapper.querySelector('.' + c('arrow-next'));
        if (!track || !prevBtn || !nextBtn) return;

        function scrollByDirection(direction) {
            var slidesToScroll = isMobile() ? 1 : DESKTOP_SLIDES_TO_SCROLL;
            var amount = getScrollStep(track, slidesToScroll);
            track.scrollBy({ left: direction * amount, behavior: 'smooth' });
        }

        prevBtn.addEventListener('click', function () {
            if (prevBtn.disabled) return;
            scrollByDirection(-1);
        });

        nextBtn.addEventListener('click', function () {
            if (nextBtn.disabled) return;
            scrollByDirection(1);
        });

        track.addEventListener('scroll', function () {
            updateNativeSliderArrowState(wrapper);
        });

        if (initializedSliderWrappers.indexOf(wrapper) === -1) {
            initializedSliderWrappers.push(wrapper);
        }

        if (!resizeListenerAttached) {
            resizeListenerAttached = true;
            window.addEventListener('resize', onSlidersResize);
        }

        requestAnimationFrame(function () {
            updateNativeSliderArrowState(wrapper);
        });
    }

    function onSlidersResize() {
        if (resizeRafPending) return;
        resizeRafPending = true;
        requestAnimationFrame(function () {
            resizeRafPending = false;
            initializedSliderWrappers.forEach(function (wrapper) {
                updateNativeSliderArrowState(wrapper);
            });
        });
    }

    function initCollectionSlider(wrapper) {
        if (!wrapper) return;
        initNativeSlider(wrapper);
    }

    function extractProductId() {
        if (typeof ShopifyAnalytics !== 'undefined' && ShopifyAnalytics.meta && ShopifyAnalytics.meta.product) {
            return ShopifyAnalytics.meta.product.id;
        }

        var pdpContainer = document.getElementById('pdp_recommendations');
        if (pdpContainer && pdpContainer.dataset.productId) {
            return pdpContainer.dataset.productId;
        }

        return null;
    }

    function extractCartIds() {
        return null;
    }

    function isCollectionPage() {
        return window.location.pathname.indexOf('/collections/') === 0;
    }

    function isBrandPage() {
        var asideEl = document.getElementById('main-search-filters') ||
            document.getElementById('main-collection-filters');
        if (!asideEl) {
            return false;
        }
        return asideEl.getAttribute('data-unbxd-brand') === 'true' ||
            !!(asideEl.querySelector('.brand-info-left') ||
                asideEl.querySelector('.brand-swipers-grid'));
    }

    function extractBrandName() {
        var brandContainer = document.getElementById('brand_recommendations');
        if (brandContainer && brandContainer.dataset.brand) {
            return brandContainer.dataset.brand;
        }

        var brandInfo = document.querySelector('.brand-info-left');
        if (brandInfo) {
            var heading = brandInfo.querySelector('h1, h2, .brand-name');
            if (heading && heading.textContent.trim()) {
                return heading.textContent.trim();
            }
        }

        return null;
    }

    function extractCategoryLevelsFromBreadcrumbs() {
        var breadcrumbSelectors = [
            '.breadcrumb a',
            '.breadcrumbs a',
            'nav.breadcrumb a'
        ];
        var breadcrumbEls = [];
        var i;

        for (i = 0; i < breadcrumbSelectors.length; i++) {
            breadcrumbEls = document.querySelectorAll(breadcrumbSelectors[i]);
            if (breadcrumbEls.length > 0) {
                break;
            }
        }

        var levels = [];
        for (i = 0; i < breadcrumbEls.length; i++) {
            var txt = breadcrumbEls[i].textContent.trim();
            if (txt) {
                levels.push(txt);
            }
        }

        var start = 0;
        if (levels.length > 0 && levels[0].toLowerCase() === 'home') {
            start = 1;
        }

        return {
            catlevel1Name: levels[start] || null,
            catlevel2Name: levels[start + 1] || null,
            catlevel3Name: levels[start + 2] || null,
            catlevel4Name: levels[start + 3] || null
        };
    }

    function extractCategoryLevels() {
        var categoryContainer = document.getElementById('category_recommendations');
        var levels = {
            catlevel1Name: null,
            catlevel2Name: null,
            catlevel3Name: null,
            catlevel4Name: null
        };

        if (categoryContainer) {
            levels.catlevel1Name = categoryContainer.dataset.catlevel1Name || null;
            levels.catlevel2Name = categoryContainer.dataset.catlevel2Name || null;
            levels.catlevel3Name = categoryContainer.dataset.catlevel3Name || null;
            levels.catlevel4Name = categoryContainer.dataset.catlevel4Name || null;
        }

        if (!levels.catlevel1Name) {
            var breadcrumbLevels = extractCategoryLevelsFromBreadcrumbs();
            ['catlevel1Name', 'catlevel2Name', 'catlevel3Name', 'catlevel4Name'].forEach(function (key) {
                if (!levels[key] && breadcrumbLevels[key]) {
                    levels[key] = breadcrumbLevels[key];
                }
            });
        }

        return levels;
    }

    function findContainersForPrefix(prefix, pageType) {
        var containers = [];
        var index = 1;

        while (true) {
            var numberedId = prefix + '_' + index;
            var el = document.getElementById(numberedId);
            if (el) {
                containers.push({
                    elementId: numberedId,
                    pageType: pageType
                });
                index++;
            } else {
                break;
            }
        }

        if (index === 1) {
            var baseEl = document.getElementById(prefix);
            if (baseEl) {
                containers.push({
                    elementId: prefix,
                    pageType: pageType
                });
            }
        }

        return containers;
    }

    var REC_CONTAINER_PREFIXES = [
        { prefix: 'pdp_recommendations', pageType: 'PRODUCT' },
        { prefix: 'cart_recommendations', pageType: 'CART' },
        { prefix: 'home_recommendations', pageType: 'HOME' },
        { prefix: 'srp_recommendations', pageType: 'HOME' },
        { prefix: 'brand_recommendations', pageType: 'BRAND' },
        { prefix: 'category_recommendations', pageType: 'CATEGORY' }
    ];

    function findFirstRecContainerElement() {
        var i;
        var prefix;
        var el;
        var index;

        if (isCollectionPage()) {
            if (isBrandPage()) {
                el = document.getElementById('brand_recommendations');
                if (el) return el;
            }
            el = document.getElementById('category_recommendations');
            if (el) return el;
        }

        for (i = 0; i < REC_CONTAINER_PREFIXES.length; i++) {
            prefix = REC_CONTAINER_PREFIXES[i].prefix;
            el = document.getElementById(prefix);
            if (el) return el;
            index = 1;
            while (true) {
                el = document.getElementById(prefix + '_' + index);
                if (!el) break;
                return el;
                index++;
            }
        }
        return null;
    }

    function pageHasRecContainers() {
        return !!findFirstRecContainerElement();
    }

    function findAllContainers() {
        if (isCollectionPage()) {
            if (isBrandPage()) {
                return findContainersForPrefix('brand_recommendations', 'BRAND');
            }
            return findContainersForPrefix('category_recommendations', 'CATEGORY');
        }

        var containers = [];

        REC_CONTAINER_PREFIXES.forEach(function (pattern) {
            if (pattern.prefix === 'brand_recommendations' || pattern.prefix === 'category_recommendations') {
                return;
            }
            containers = containers.concat(
                findContainersForPrefix(pattern.prefix, pattern.pageType)
            );
        });

        return containers;
    }

    function detectPageContext() {
        var allContainers = findAllContainers();
        if (allContainers.length === 0) {
            return null;
        }

        var firstContainer = allContainers[0];
        var pageType = hasSrpContainers(allContainers) ? 'HOME' : firstContainer.pageType;
        var productId = null;
        var cartIds = null;
        var brandName = null;
        var categoryLevels = null;

        if (pageType === 'PRODUCT') {
            productId = extractProductId();
        } else if (pageType === 'CART') {
            cartIds = extractCartIds();
        } else if (pageType === 'BRAND') {
            brandName = extractBrandName();
        } else if (pageType === 'CATEGORY') {
            categoryLevels = extractCategoryLevels();
        }

        return {
            pageType: pageType,
            containers: allContainers,
            productId: productId,
            cartIds: cartIds,
            brandName: brandName,
            categoryLevels: categoryLevels
        };
    }

    function initializePageContext() {
        pageContext = detectPageContext();

        window._unbxd_recs_containers = pageContext ? pageContext.containers : [];
        window._unbxd_recs_defaultElementId = (pageContext && pageContext.containers.length > 0)
            ? pageContext.containers[0].elementId
            : null;

        if (!pageContext) {
            API_URL = null;
            return;
        }

        var recsFields = [
            'title', 'uniqueId', 'imageUrl', 'productUrl', 'price',
            'compareAtPrice', 'availability', 'vendor', 'handle',
            'variantTotal', 'computed_discount', 'totalInventory'
        ].join(',');

        var apiUrl = 'https://recommendations.unbxd.io/v3.0/' +
            getApiKey() +
            '/' +
            getSiteName() +
            '/recommendation?template=false&pageType=' +
            encodeURIComponent(pageContext.pageType) +
            '&uid=' +
            encodeURIComponent(unbxdRequestId) +
            '&fields=' + encodeURIComponent(recsFields);

        if (pageContext.pageType === 'PRODUCT' && pageContext.productId) {
            apiUrl += '&id=' + encodeURIComponent(pageContext.productId);
        } else if (pageContext.pageType === 'CART' && pageContext.cartIds) {
            apiUrl += '&id=' + encodeURIComponent(pageContext.cartIds);
        } else if (pageContext.pageType === 'BRAND' && pageContext.brandName) {
            apiUrl += '&brand=' + encodeURIComponent(pageContext.brandName);
        } else if (pageContext.pageType === 'CATEGORY' && pageContext.categoryLevels) {
            ['catlevel1Name', 'catlevel2Name', 'catlevel3Name', 'catlevel4Name'].forEach(function (key) {
                if (pageContext.categoryLevels[key]) {
                    apiUrl += '&' + key + '=' + encodeURIComponent(pageContext.categoryLevels[key]);
                }
            });
        }

        API_URL = apiUrl;
    }

    var _widgetContainerIndex = 0;

    function getElementIdForWidget(widget, widgetIndex) {
        var containers = window._unbxd_recs_containers || [];
        if (containers.length === 0) {
            return null;
        }

        var containerIndex = (widgetIndex !== undefined) ? widgetIndex : _widgetContainerIndex;

        if (containerIndex < containers.length) {
            var container = containers[containerIndex];
            if (widgetIndex === undefined) {
                _widgetContainerIndex++;
            }
            return container.elementId;
        }

        return containers[containers.length - 1].elementId;
    }

    function hasSrpContainers(containers) {
        return containers.some(function (container) {
            return container.elementId.indexOf('srp_recommendations') === 0;
        });
    }

    function getRecommendedForYouWidget(widgets) {
        if (!widgets || widgets.length === 0) {
            return null;
        }

        var i;
        for (i = 0; i < widgets.length; i++) {
            var title = (widgets[i].widgetTitle || '').toLowerCase();
            if (title.indexOf('recommended') !== -1) {
                return widgets[i];
            }
        }

        return widgets.length > 2 ? widgets[2] : null;
    }

    function renderWidget(widget, analyticsData, widgetIndex) {
        try {
            var elementId = getElementIdForWidget(widget, widgetIndex);
            if (!elementId) return;

            var targetElement = document.getElementById(elementId);
            if (!targetElement) return;

            var recommendations = widget.recommendations || [];
            if (recommendations.length === 0) return;

            var sliderHTML = generateSliderHTML(widget, analyticsData);
            targetElement.innerHTML = sliderHTML;

            var wrapper = targetElement.querySelector('collection-slider-' + SLIDER_SUFFIX) ||
                targetElement.querySelector('.' + c(''));
            initCollectionSlider(wrapper);
        } catch (e) {
            console.error('[Unbxd Recs] Error rendering widget:', e);
        }
    }

    function fetchAndRenderRecommendations() {
        if (!API_URL) return;

        fetch(API_URL)
            .then(function (response) {
                if (!response.ok) {
                    throw new Error('Network response was not ok: ' + response.status);
                }
                return response.json();
            })
            .then(function (data) {
                if (!data || !data.response || !data.response.widgets) return;

                var widgets = data.response.widgets;
                var requestId = window.unbxdRequestId ||
                    (data.recsMetaData && data.recsMetaData.requestId) ||
                    'req-' + Date.now();
                var containers = window._unbxd_recs_containers || [];

                if (hasSrpContainers(containers)) {
                    var recWidget = getRecommendedForYouWidget(widgets);
                    if (recWidget && (recWidget.recommendations || []).length) {
                        renderWidget(recWidget, {
                            widgetNum: recWidget.widgetId || '',
                            pageType: 'HOME',
                            requestId: requestId
                        }, 0);
                    }
                    return;
                }

                renderWidgetsSequential(widgets, requestId, 0);
            })
            .catch(function (error) {
                console.error('[Unbxd Recs] Error fetching recommendations:', error);
            });
    }

    function scheduleNextFrame(fn) {
        if (typeof requestAnimationFrame === 'function') {
            requestAnimationFrame(fn);
        } else {
            setTimeout(fn, 0);
        }
    }

    function renderWidgetsSequential(widgets, requestId, index) {
        if (!widgets || index >= widgets.length) return;

        var widget = widgets[index];
        var analyticsData = {
            widgetNum: widget.widgetId || '',
            pageType: (pageContext && pageContext.pageType) ? pageContext.pageType : 'HOME',
            requestId: requestId
        };
        renderWidget(widget, analyticsData, index);

        if (index + 1 >= widgets.length) return;
        scheduleNextFrame(function () {
            renderWidgetsSequential(widgets, requestId, index + 1);
        });
    }

    function runRecommendations() {
        initializePageContext();
        if (!API_URL) return;
        fetchAndRenderRecommendations();
    }

    function scheduleRecommendations() {
        if (!pageHasRecContainers()) return;

        var firstEl = findFirstRecContainerElement();

        function attachObserver() {
            if (firstEl && 'IntersectionObserver' in window) {
                var observer = new IntersectionObserver(function (entries) {
                    if (!entries[0] || !entries[0].isIntersecting) return;
                    observer.disconnect();
                    runRecommendations();
                }, { rootMargin: RECS_IO_ROOT_MARGIN });
                observer.observe(firstEl);
                return;
            }

            if ('requestIdleCallback' in window) {
                requestIdleCallback(runRecommendations, { timeout: RECS_IDLE_TIMEOUT_MS });
            } else {
                setTimeout(runRecommendations, 1);
            }
        }

        function whenIdle(cb) {
            if ('requestIdleCallback' in window) {
                requestIdleCallback(cb, { timeout: RECS_IDLE_TIMEOUT_MS });
            } else {
                setTimeout(cb, 1);
            }
        }

        whenIdle(attachObserver);
    }

    function bootRecs() {
        if (!pageHasRecContainers()) return;
        scheduleRecommendations();
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', bootRecs);
    } else {
        bootRecs();
    }

})();
